export class TariffService {
    tariffApi;
    constructor(tariffApi) {
        this.tariffApi = tariffApi;
    }
    fetchTariffDescriptionByUuid(uuid) {
        // let tariff = fakeTariffs.find(t => t.uuid === uuid)
        // if (!tariff) {
        //     Promise.reject("Tariff not found");
        // }
        // return Promise.resolve(tariff!)
        return this.tariffApi.getTariffByUUID(uuid);
    }
}
